import { TicketListController } from './ticket-list/ticket-list.controller';

export const TicketController = (): React.JSX.Element => {
  return <TicketListController />;
};
